<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 12 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.41421 9C2.52331 9 2.07714 7.92286 2.70711 7.29289L5.29289 4.70711C5.68342 4.31658 6.31658 4.31658 6.70711 4.70711L9.2929 7.29289C9.92286 7.92286 9.47669 9 8.58579 9H3.41421Z"
      fill="currentColor"
      opacity="0.3"
    />
    <path d="M3.41421 12C2.52331 12 2.07714 13.0771 2.70711 13.7071L5.29289 16.2929C5.68342 16.6834 6.31658 16.6834 6.70711 16.2929L9.2929 13.7071C9.92286 13.0771 9.47669 12 8.58579 12H3.41421Z" fill="currentColor" />
  </svg>
</template>
